var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.activeTokenizerIsBasisTheory
        ? _c("basis-theory-form", {
            ref: "basisTheoryForm",
            on: {
              "set-loading": (onOrOff) => _vm.$emit("set-loading", onOrOff),
              "token-created": (data) => _vm.$emit("token-created", data),
              "token-error": (err) => _vm.$emit("token-error", err),
            },
          })
        : _vm.activeTokenizerIsFluidpay
        ? _c("fluid-pay-form", {
            ref: "fluidPayForm",
            attrs: {
              "api-key": _vm.fluidpayApiKey,
              "api-url": _vm.fluidpayApiUrl,
              "first-name": _vm.firstName,
              "last-name": _vm.lastName,
            },
            on: {
              "set-loading": (onOrOff) => _vm.$emit("set-loading", onOrOff),
              verified: (data) => _vm.$emit("verified", data),
              "token-error": (err) => _vm.$emit("token-error", err),
            },
          })
        : _vm.activeTokenizerIsPayliance
        ? _c("payliance-form", {
            ref: "paylianceForm",
            attrs: { configuration: _vm.paylianceConfiguration },
            on: {
              "set-loading": (onOrOff) => _vm.$emit("set-loading", onOrOff),
              verified: (data) => _vm.$emit("verified", data),
              "token-error": (err) => _vm.$emit("token-error", err),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }